import { t } from '@/utils/i18n'
import { useState } from 'react'
import basic from '@/apis/modules/basic'

const { getCurrencyList } = basic

function HttpDemo1() {
  const [pageInfo, setPageInfo] = useState({
    pageNum: 1,
    pageSize: 10,
  })
  const {
    data = [],
    loading,
    error,
    isDataEmpty,
    hasNextPage,
    msg,
    runAsync: onGetCurrencyList,
  } = getCurrencyList(
    {
      ...pageInfo,
      corpId: 'xxxx',
    },
    {
      isLastRequest: true,
    }
  )

  async function handleGetCurrencyList() {
    if (!hasNextPage) return
    await onGetCurrencyList()
  }

  function handleLoadMore() {
    setPageInfo({
      ...pageInfo,
      pageNum: pageInfo.pageNum + 1,
    })
    handleGetCurrencyList()
  }

  return (
    <>
      <button onClick={handleGetCurrencyList}>{t('请求数据')}</button>
      <button onClick={handleLoadMore}>{t('加载下一页')}</button>
      <div>
        {loading && t('请求中loading...')}

        {!loading && (
          <>
            {error && t('请求出错了, {{msg}}', { msg: msg })}

            {!error && (
              <div>
                <div>msg: {msg}</div>
                <div>
                  data:{' '}
                  {data.map((item) => item.currencyCountryNameZhCn).join(',')}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <div>{isDataEmpty && t('列表数据为空')}</div>
    </>
  )
}

export default HttpDemo1
